<template>
	<div class="invoice">
		<addinvoice ref="addinvoice" v-show="isshowaddinvoice" @addinvoicecallback="addinvoicecallback"></addinvoice>
		
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import addinvoice from '@/components/invoice/addinvoice.vue';
export default {
	components: {
		addinvoice
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return  {}
			}
		}
	},
	data() {
		return {
			isshowaddinvoice:false,
			type:'',
			pkval:'',
			handletype:'out',
			invoicetype:'',
			divclass:'invoice'
		}
	},
	mounted() {
		//this.init(param);
	},
	methods:{
		init(param){
			var that=this;
			//invoice
			this.$tool.loading('正在加载', this.divclass);
			if(param.handletype!=undefined)
				this.handletype=param.handletype;
			this.$apipost.get.OpenInvoice({paraminfo:param.param}).then(res => {
				this.$tool.loadingclose();
				if(res.pkval!=undefined)
					that.pkval=res.pkval;
				if(res.type!=undefined)
					that.invoicetype=res.type;
				if(res.state=='1'){
					that.invoicecallback(true);
				}
				else if(res.state=='2'){
					if(res.list.length>0)
					{
						if(that.type!=''){
							var paraminfo=res.list[0];
							that.addinvoicecallback({event:'save',paraminfo:paraminfo});
						}else{
							that.isshowaddinvoice=true;
							this.$nextTick(function() {
								that.$refs.addinvoice.init({
									crminfo:res.list[0],
									lang:res.lang,
									invoicetype:res.type,
									vipaccount:res.vipaccount,
									crm_id:res.id
								});
							});
						}
					}
				}
				else if(res.state=='3')
				{
					that.isshowaddinvoice=true;
					this.$nextTick(function() {
						that.$refs.addinvoice.init({
							crminfo:{},
							lang:res.lang,
							invoicetype:res.type,
							vipaccount:res.vipaccount,
							crm_id:res.id
						});
					});
				}
				else
				{
					this.$tool.message(res.message, 0);
					that.invoicecallback(false);
				}
			}).catch(e=>{
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请刷新', 0);
			});
		},
		invoicecallback(result){
			//debugger
			this.$emit('invoicecallback',{result:result,pkval:this.pkval,invoicetype:this.invoicetype});
		},
		addinvoicecallback(e){
			this.isshowaddinvoice=false;
			if(e.event=='save'){
				var that=this;
				var paraminfo={
					info:e.paraminfo
				};
				paraminfo.pkval=that.pkval;
				paraminfo.invoicetype=that.invoicetype;
				paraminfo.handletype=that.handletype;
				if(localStorage.getItem('userid')!=null)
					paraminfo.u_userid=localStorage.getItem('userid');
				this.$tool.loading('正在开具发票', this.divclass);
				this.$apipost.post.SaveInvoice({paraminfo:paraminfo}).then(res => {
					this.$tool.loadingclose();
					if(res.state=='1')
						that.invoicecallback(true);
					else
						this.$tool.message(res.message, 0);
				});
			}
		}
	}
}
</script>

<style>
</style>
